import React from 'react';
import { action as deleteMember } from './action';
import { useMutation, useQueryClient } from 'react-query';
import { USER_LIST_MODULE_NAME } from '../user-list';
import { LoaderElem } from '../../common/loader';
import { ModalConfirmElem } from '../../common/modal-confirm';
import { ACTION_ERROR_INTER } from './constant';
import { AlertActionElem } from '../../common/alert-action';

export const Container: React.FC<{
  userId: string;
  open: boolean;
  onClose: () => void;
}> = ({ userId, onClose, open }) => {
  const queryClient = useQueryClient();

  const action = useMutation(() => deleteMember(userId), {
    onSuccess: () => {
      return queryClient.invalidateQueries(USER_LIST_MODULE_NAME);
    },
  });

  // const action = useMutation(() => createPayment({ data: 2 }), {});

  // const isLoading = () => {
  //   if (action.isLoading) {
  //     return true;
  //   }
  // };

  // const onClick = () => {
  //   action.mutate();
  // };

  const isLoading = () => {
    if (action.isLoading) {
      return true;
    }
  };

  const onClick = () => {
    action.mutate();
  };

  const isError = () => {
    if (action.isError && !action.isLoading && getErrorMessage()) {
      return true;
    }
  };

  const getErrorMessage = () => {
    const error: ACTION_ERROR_INTER = action.error as ACTION_ERROR_INTER;
    if (error) {
      return error.message;
    }
  };

  return (
    <div style={{ display: 'none' }}>
      {isLoading() && <LoaderElem />}

      <ModalConfirmElem
        action={onClick}
        open={open}
        onClose={onClose}
        type="confirm"
      ></ModalConfirmElem>
      {isError() && <AlertActionElem tid={getErrorMessage()} />}
    </div>
  );
};
